// extracted by mini-css-extract-plugin
export default {"external":"aWKWDH","skeleton":"bWKWDH","block":"cWKWDH","assetName":"dWKWDH"};